import { React, useState, useEffect, useContext } from "react";
import Table from "react-bootstrap/Table";
import ClipLoader from "react-spinners/ClipLoader";
import GlobalContext from "../../providers/GlobalProvider";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./Transactions.css";
import Button from "react-bootstrap/Button";

const Transactions = ({ type }) => {
  const navigate = useNavigate();
  const [invoicesType, setInvoicesType] = useState(type || "sal");
  const [loading, setLoading] = useState(true);
  const [transactionData, setTransactionData] = useState([]);
  const { defaultMapper } = useContext(GlobalContext);
  const [customersData, setCustomersData] = useState([]);
  const [countriesData, setCountriesData] = useState([]);
  const [servicesData, setServicesData] = useState([]);
  const [aircraftData, setAircraftData] = useState([]);
  const [vendorsData, setVendorsData] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [transactionsCount, setTransactionsCount] = useState(0);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState({});
  const [rowData, setRowData] = useState({
    invoiceLineId: "",
    name: "",
    amount: null,
    total: null,
  });
  const invoicesTypesOptions = {
    Sales: "sal",
    Vendor: "vendor",
    CreditNotes: "credit note",
  };
  const IASLiveMapper = "IAS Libra Live";
  const url = "api/transactions";

  const getTransactionData = async (page, size, type = "sal") => {
    console.log(
      "Headers inside transactions ",
      axios.defaults.headers.common["Mapper"]
    );
    try {
      const response = await axios.get(
        url + `?pageNumber=${page}&pageSize=${size}&type=${type}`
      );
      setTransactionData(response.data.transactions);
      setTransactionsCount(response.data.transactionCount);
      setServicesData(response.data.flightServiceCategories);
      setCountriesData(response.data.countries);
      setCustomersData(response.data.customers);
      setAircraftData(response.data.aircraft);
      setVendorsData(response.data.vendors);
    } catch (e) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  const getName = (arr, id) => {
    if (arr) {
      const prop = arr.find((obj) => obj.id == id);
      if (prop) {
        return prop.name;
      } else {
        return "No Name Available";
      }
    }
  };

  const getId = (name) => {
    if (type == "vendor") {
      const record = vendorsData.find((obj) => obj.name == name);
      return record.id;
    } else {
      const record = customersData.find((obj) => obj.name == name);
      return record.id;
    }
  };
  // update to take vendor invoices
  const handleUpdateClick = (transaction) => {
    let updatedData;

    updatedData = {
      InvoiceLineId: rowData.invoiceLineId,
      Id: getId(rowData.name),
      Amount: +rowData.amount,
      Total: +rowData.total,
    };

    axios.patch(url, updatedData); // todo: fix controller to take id

    // update UI
    const updatedTransactionIndex = transactionData.findIndex(
      (t) => t.invoiceLineId === rowData.invoiceLineId
    );
    if (updatedTransactionIndex !== -1) {
      const updatedTransactionData = [...transactionData];
      updatedTransactionData[updatedTransactionIndex] = {
        ...updatedTransactionData[updatedTransactionIndex],
        amount: +rowData.amount,
        total: +rowData.total,
        Id: getId(rowData.name),
      };
      setTransactionData(updatedTransactionData);
    }
    handleCancelClick();
  };

  const handleEdit = (transaction) => {
    setIsEditing(true);
    setEditingRowId(transaction.invoiceLineId);
    setRowData({
      invoiceLineId: transaction.invoiceLineId,
      name: getName(customersData, transaction.clientId), // Todo: update to take vendor invoice
      amount: transaction.amount,
      total: transaction.total,
    });
  };

  const handleCancelClick = () => {
    setIsEditing(false);
    setEditingRowId(null);
    setRowData({
      invoiceLineId: "",
      name: "",
      amount: null,
      total: null,
    });
  };
  const handleAmountChange = (event) => {
    const editedAmount = event.target.value;
    setRowData((prevState) => ({
      ...prevState,
      amount: editedAmount,
    }));
  };
  const handleTotalChange = (event) => {
    const editedTotal = event.target.value;
    setRowData((prevState) => ({
      ...prevState,
      total: editedTotal,
    }));
  };
  const handleClientChange = (event) => {
    const editedClient = event.target.value;
    setRowData((prevState) => ({
      ...prevState,
      name: editedClient,
    }));
  };
  const handleVendorChange = (event) => {
    const editedVendor = event.target.value;
    setRowData((prevState) => ({
      ...prevState,
      name: editedVendor,
    }));
  };

  const handleImport = async () => {
    try {
      const importResponse = await axios.post(url + `/import`);
    } catch (e) {
      console.error(e);
    }
  };
  const handleExport = async () => {
    try {
      const ExportResponse = await axios.post(url + `/export`);
      if (ExportResponse.length > 0) {
        setError(ExportResponse);
      }
    } catch (e) {
      setError(e.response.data);
      console.error(e);
    }
  };

  const handleSelectInvoiceType = (event) => {
    setInvoicesType(event.target.value);
  };

  const handlePageChange = (page) => setCurrentPage(page);
  const totalPages = Math.ceil(transactionsCount / pageSize);

  const clearErrorHandler = () => {
    setError({});
  };
  useEffect(() => {
    console.log("defaultMapper", defaultMapper);
    setTransactionData([]);
    getTransactionData(currentPage, pageSize, invoicesType);
  }, [defaultMapper, currentPage, invoicesType, error]);

  if (loading) {
    return (
      <div>
        <ClipLoader
          loading={loading}
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  return (
    <>
      <select
        className="col-4 mt-2 mb-5 selectors"
        onChange={handleSelectInvoiceType}
        value={invoicesType}
      >
        <option value="">Select Invoices Type</option>
        {Object.keys(invoicesTypesOptions).map((cc) => (
          <option key={cc} value={invoicesTypesOptions[cc]}>
            {cc}
          </option>
        ))}
      </select>
      <Table hover bordered="false" responsive order class="mt-4 mb-4">
        <thead>
          <tr>
            <th>Transaction Id</th>
            <th>Invoice Line Id</th>
            {customersData && <th>Customer</th>}
            {!customersData && defaultMapper != IASLiveMapper && (
              <th>Vendor</th>
            )}
            <th>Description</th>
            {defaultMapper != IASLiveMapper && (
              <>
                <th>Category</th>
                <th>Aircraft</th>
                <th>Service Country</th>
              </>
            )}
            <th>Amount</th>
            {defaultMapper != IASLiveMapper && <th>Total</th>}
            <th>Value Date</th>
            <th>Date</th>
            {/* <th>Posted</th> */}
            {/* <th></th> */}
          </tr>
        </thead>
        <tbody>
          {transactionData && transactionData.length > 0 ? (
            transactionData.map((transaction) => {
              const isCurrentRowEditing =
                editingRowId === transaction.invoiceLineId;
              return (
                <tr key={transaction.invoiceLineId}>
                  <td>{transaction.transId}</td>
                  <td>{transaction.invoiceLineId}</td>

                  {customersData && (
                    <td>{getName(customersData, transaction.clientId)}</td>
                  )}

                  {!customersData && defaultMapper != IASLiveMapper && (
                    <td>{getName(vendorsData, transaction.vendorId)}</td>
                  )}
                  <td>{transaction.description}</td>
                  {defaultMapper != IASLiveMapper && (
                    <>
                      {<td>{getName(servicesData, transaction.categoryId)}</td>}
                      {<td>{getName(aircraftData, transaction.aircraftId)}</td>}
                      <td>
                        {getName(countriesData, transaction.serviceCountryId)}
                      </td>
                    </>
                  )}
                  <td>
                    {isCurrentRowEditing ? (
                      <input
                        type="number"
                        value={rowData.amount}
                        onChange={handleAmountChange}
                      />
                    ) : (
                      transaction.amount
                    )}
                  </td>
                  {defaultMapper != IASLiveMapper && <td>transaction.total</td>}
                  <td>{transaction.valueDate}</td>
                  <td>{transaction.date}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="22">No Transactions Found</td>
            </tr>
          )}
        </tbody>
      </Table>
      {/* Pagination start*/}
      <div>
        <Button
          variant="outline-light"
          onClick={() => handlePageChange(1)}
          disabled={currentPage == 1}
        >
          First
        </Button>
        <Button
          variant="outline-light"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage == 1}
        >
          Previous
        </Button>
        <span className="pagination-count">
          Page {currentPage} of {totalPages}
        </span>
        <Button
          variant="outline-light"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage == totalPages}
        >
          Next
        </Button>
        <Button
          variant="outline-light"
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage == totalPages}
        >
          Last
        </Button>
      </div>
      {/* Pagination end*/}
      <Link to="/">
        <Button variant="outline-danger">Main Menu</Button>
      </Link>
      <Button variant="outline-primary" onClick={handleImport}>
        Import Data
      </Button>
      ;
      <Button variant="outline-primary" onClick={handleExport}>
        Export Data
      </Button>
      ;
      {error.success && (
        <div className="error-div">
          <p className="error-message">{error.success}</p>
          <Button variant="secondary" size="sm" onClick={clearErrorHandler}>
            Ok
          </Button>
        </div>
      )}
      {/* <h5 style={{ color: "red" }}>{error}</h5>
      <h5 style={{ color: "green" }}>{success}</h5> */}
    </>
  );
};

export default Transactions;
